import React from "react";
import toastr from "toastr";
import { TextField, Button, Grid, Input, FormLabel, Box, FormControlLabel, RadioGroup, Radio } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import { Select, Typography } from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import UserHelpers from "./UserHelpers";
import { makeDELETERequestOnUserServiceWithQueryParameter } from "../../Api/api";

const useStyles = makeStyles((theme) => ({
  textField: {
    width: "100%",
  },
  paper: {
    width: "500px",
    margin: "35px auto",
    justifyContent: "center",
    alignItems: "center",
  },
  root: {
    justifyContent: "center",
    alignItems: "center",
  },
  img: {
    height: 355,
    maxWidth: 600,
    overflow: "hidden",
    display: "block",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const DematDetailsInformationGrid = (props) => {
  const classes = useStyles();
  const initialState = {
    dpType: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "dp_type"),
    dpName: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "dp_name"),
    clientId: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "client_id"),
    dpID: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "dp_id"),
    kycPassword: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "kyc_doc_plaintext_password"),
    oldClientId: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "client_id"),
    accountStatus: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "account_status") || "",
    panNumbers: UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "pan_numbers") || "",
  };

  const [currentState, setCurrentState] = React.useState(initialState);
  const dpTypeOptions = ["NSDL", "CDSL"];
  const [oldClientId, setOldClientId] = React.useState(
    UserHelpers.getValueOrEmptyForDemat(props.dematDetails, "client_id")
  );
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [createCond, setCreateCond] = React.useState(
    props.dematDetails?.client_id === "" || props.dematDetails?.clientId === ""
  );

  const existingImage = props.dematDetails?.image;
  const isExistingPdf = existingImage && existingImage.startsWith("JVBERi0");

  const handleChange = (event) => {
    event.persist();
    const { name, value } = event.target;
    setCurrentState((previousValues) => {
      let newState = {
        ...previousValues,
        [name]: value,
      };
      if (name === 'accountStatus') {
        newState.panNumbers = '';
      }
      return newState;
    });
  };

  const addDematDetails = (event) => {
    event.preventDefault();
    currentState.file = selectedFile;
    props.addDematDetails(event, currentState);
  };

  const saveDematDetails = (event) => {
    event.preventDefault();
    let state = currentState;
    state.oldClientId = oldClientId;
    if (selectedFile) {
      state.image = selectedFile;
    }
    setOldClientId(currentState.clientId);
    props.saveDematDetails(event, state);
  };

  
  const handleBase64Download = () => {
    if (!existingImage) return;

    const isPdf = existingImage.startsWith("JVBERi0");
    const mimeType = isPdf ? "application/pdf" : "image/png";
    const extension = isPdf ? "pdf" : "png";
    const filename = props.dematDetails?.image_filename || `demat_proof.${extension}`;

    try {
      const byteCharacters = atob(existingImage);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: mimeType });
      const url = URL.createObjectURL(blob);
      
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      if (isPdf) link.target = "_blank";
      
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      setTimeout(() => URL.revokeObjectURL(url), 100);
    } catch (error) {
      console.error("Download error:", error);
      toastr.error("Unable to download file.");
    }
  };

  const normalizePanArray = (panNumbers) => {
    let arr = [];
    if (!panNumbers) return ["", "", ""];
    if (Array.isArray(panNumbers)) {
      arr = panNumbers;
    } else if (typeof panNumbers === "string") {
      arr = panNumbers.split(",").map((p) => p.trim());
    }
    while (arr.length < 3) arr.push("");
    return arr;
  };

  const getPanArray = (panNumbers) => {
    const arr = normalizePanArray(panNumbers);
    return [arr[1], arr[2]];
  };

  const pans = getPanArray(currentState.panNumbers);

  return (
    <>
      <FormControl variant="outlined" className={classes.formControl} style={{ width: "100%" }}>
        <InputLabel id="demo-simple-select-outlined-label">DP Type</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          name="dpType"
          value={currentState.dpType}
          onChange={(event) => handleChange(event)}
          label="DP Type"
        >
          {dpTypeOptions && dpTypeOptions.length > 0 && dpTypeOptions.map((dpTypeOption, index) => (
            <MenuItem value={dpTypeOption} key={index}>
              {dpTypeOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Box display="flex" alignItems="center" mt={2}>
        <Box mr={1} ml={1}>
          <FormLabel id="account-status-label" style={{ whiteSpace: "nowrap" }}>Account Status</FormLabel>
        </Box>
        <Box ml={1}>
          <RadioGroup row aria-labelledby="account-status-label" name="accountStatus" value={currentState.accountStatus} onChange={handleChange}>
            <FormControlLabel value="Sole" control={<Radio color="primary" />} label="Sole" />
            <FormControlLabel value="Joint" control={<Radio color="primary" />} label="Joint" />
          </RadioGroup>
        </Box>
      </Box>

      {currentState.accountStatus === "Joint" && (
        <>
          <Typography sx={{ fontSize: 12, fontWeight: 500, mt: 1, color: "#555", width: 'w-full' }}>
            Please enter all joint holder PAN information below.
          </Typography>
          <Box display="flex" alignItems="center" mt={1}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField type="text" label="PAN 2" variant="outlined" size="small" fullWidth value={(pans[0] || "").toUpperCase()} onChange={(e) => {
                  const newVal = e.target.value.toUpperCase();
                  let arr = normalizePanArray(currentState.panNumbers); arr[1] = newVal;
                  setCurrentState((prev) => ({ ...prev, panNumbers: arr.join(",") }));
                }} helperText="Required, exactly 10 characters" error={!!pans[0] && !/^[A-Z0-9]{10}$/.test(pans[0].trim())} />
              </Grid>
              <Grid item xs={6}>
                <TextField type="text" label="PAN 3 (Optional)" variant="outlined" size="small" fullWidth value={(pans[1] || "").toUpperCase()} onChange={(e) => {
                  const newVal = e.target.value.toUpperCase();
                  let arr = normalizePanArray(currentState.panNumbers); arr[2] = newVal;
                  setCurrentState((prev) => ({ ...prev, panNumbers: arr.join(",") }));
                }} helperText="Optional, must be 10 characters if entered" error={!!pans[1] && !/^[A-Z0-9]{10}$/.test(pans[1].trim())} />
              </Grid>
            </Grid>
          </Box>
        </>
      )}

      <TextField type="text" name="dpName" variant="outlined" fullWidth style={{ marginTop: "20px" }} helperText="DP Name" onChange={handleChange} value={currentState.dpName} />
      <TextField type="text" name="clientId" variant="outlined" fullWidth helperText="Client ID" onChange={handleChange} value={currentState.clientId} />

      {currentState.dpType === "NSDL" && (
        <TextField type="text" name="dpID" variant="outlined" fullWidth helperText="DP ID" onChange={handleChange} value={currentState.dpID} />
      )}

      <TextField type="text" name="kycPassword" variant="outlined" fullWidth onChange={handleChange} helperText="Password - If Blank, then no password is set by client" value={currentState.kycPassword} />

      <FormControl fullWidth style={{ marginTop: "20px" }}>
        <InputLabel>Upload File</InputLabel>
        <Input
          type="file"
          name="file"
          onChange={(e) => setSelectedFile(e.target.files[0])}
          inputProps={{ accept: "image/*,.pdf" }}
        />
      </FormControl>

      {selectedFile && (
        <Grid item style={{ marginTop: 16 }}>
          {selectedFile.type === "application/pdf" ? (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, p: 1.5, backgroundColor: "#ffebee", borderRadius: 1, border: "1px solid #ef9a9a" }}>
              <PictureAsPdfIcon sx={{ fontSize: 40, color: "#d32f2f" }} />
              <Typography variant="body2" color="text.secondary">PDF Selected: {selectedFile.name}</Typography>
            </Box>
          ) : (
            <img src={URL.createObjectURL(selectedFile)} alt="File Preview" style={{ maxWidth: "100%", maxHeight: "200px" }} />
          )}
        </Grid>
      )}

      {!selectedFile && existingImage && (
        <Box style={{ marginTop: 16 }}>
          {isExistingPdf ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, p: 1.5, backgroundColor: "#ffebee", borderRadius: 1, border: "1px solid #ef9a9a" }}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <PictureAsPdfIcon sx={{ fontSize: 40, color: "#d32f2f" }} />
                <Typography variant="body2" color="text.secondary">PDF Document Uploaded</Typography>
              </Box>
              <Button variant="outlined" color="primary" size="small" onClick={handleBase64Download} style={{ alignSelf: "flex-start", marginTop: 8 }}>
                Download PDF
              </Button>
            </Box>
          ) : (
            <Box>
              <img
                src={`data:image/png;base64,${existingImage}`}
                alt="Existing Demat"
                style={{ maxWidth: "100%", maxHeight: "200px", borderRadius: "6px", border: "1px solid #ccc", objectFit: "contain" }}
              />
              <Button variant="outlined" color="primary" size="small" onClick={handleBase64Download} style={{ marginTop: 8 }}>
                Download Image
              </Button>
            </Box>
          )}
        </Box>
      )}

      <Button variant="contained" color="primary" style={{ width: 300, marginTop: 24 }} onClick={createCond ? addDematDetails : saveDematDetails}>
        {createCond ? "Create" : "Update"}
      </Button>
    </>
  );
};

export default DematDetailsInformationGrid;